<template>
  <PostLessonPrompt
    v-if="showPrompt && currentLessonData"
    :lesson-id="currentLessonData.lessonId"
    :teacher-id="currentLessonData.teacherId"
    :teacher-name="currentLessonData.teacherName"
    :instrument="currentLessonData.instrument"
    :is-visible="showPrompt"
    @close="hidePostLessonPrompt"
    @feedback-submitted="handleFeedbackSubmitted"
    @account-creation-requested="handleAccountCreationRequested"
  />
</template>

<script>
import PostLessonPrompt from "./PostLessonPrompt.vue";
import { usePostLessonPrompt } from "@/composables/usePostLessonPrompt";

export default {
  name: "GlobalPostLessonPrompt",
  components: {
    PostLessonPrompt,
  },
  setup() {
    const {
      showPrompt,
      currentLessonData,
      hidePostLessonPrompt,
      handleFeedbackSubmitted,
      handleAccountCreationRequested,
    } = usePostLessonPrompt();

    return {
      showPrompt,
      currentLessonData,
      hidePostLessonPrompt,
      handleFeedbackSubmitted,
      handleAccountCreationRequested,
    };
  },
};
</script>
